import { DESCRIPTION, INCIDENT_TYPE } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { routes } from "@/routes/utils";
import { schema } from "./validations";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Incident Type",
    moduleRoute: `${routes.masterData}/${routes.incidentType}`,
    schema,
    defaultValues: { [INCIDENT_TYPE]: "", [DESCRIPTION]: "" },
    nameFieldKey: INCIDENT_TYPE,
    queryKeyToInvalidate: "incident-types",
    module: "incident-types",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Incident Type"
    />
  );
};

export default AddEdit;
